<template>
  <div id="app">
    <Head></Head>
    <div class="banner">
      <img
        v-if="this.$store.state.currentLang === 'zh'"
        :src="this.$path + '/assets/images/banner-wifi-zh.png'"
        :alt="$t('langs.aolei')"
      />
      <img
        v-if="this.$store.state.currentLang === 'en'"
        :src="this.$path + '/assets/images/banner-wifi-en.png'"
        :alt="$t('langs.aolei')"
      />
    </div>
    <div class="center_center">
      <div class="main_context_wifi">
        <img :src="this.$path + '/assets/images/main-wifi.png'" />
        <span>
          <div class="title_context_wifi">WiFi {{ $t("langs.communication") }}</div>
          <div class="memo_context_wifi">
            {{ $t("langs.storageinverter") }}
          </div>
          <div class="memo_botton_wifi">
            <div class="imagewifi">
              <img
                referrerpolicy="no-referrer"
                :src="this.$path + '/assets/images/iphone_wifi.png'"
              />
              <span>{{ $t("langs.connectpc") }}</span>
            </div>
            <div class="imagewifi">
              <img
                referrerpolicy="no-referrer"
                :src="this.$path + '/assets/images/monitor.png'"
              />
              <span>{{ $t("langs.nemotenetwork") }}</span>
            </div>
            <div class="imagewifi">
              <img
                referrerpolicy="no-referrer"
                :src="this.$path + '/assets/images/upload.png'"
              />
              <span>{{ $t("langs.firmware") }}</span>
            </div>
          </div>
        </span>
      </div>
    </div>
    <div class="box_center_pd">
      <span class="text_pd">{{ $t("langs.parameter") }}</span>
      <div class="row_line">
        <span class="td_line"></span>
      </div>
      <img
        v-if="this.$store.state.currentLang === 'zh'"
        :src="this.$path + '/assets/images/power-parameter-wifi-zh.png'"
        class="wifi_image"
        :alt="$t('langs.parameter')"
      />
      <img
        v-if="this.$store.state.currentLang === 'en'"
        :src="this.$path + '/assets/images/power-parameter-wifi-en.png'"
        class="wifi_image"
        :alt="$t('langs.parameter')"
      />
    </div>
    <Footer></Footer>
    <Hover></Hover>
  </div>
</template>

<script>
import Head from "../components/head/head.vue";
import Footer from "../components/footer/footer.vue";
import Hover from '../components/hover';

export default {
  name: "centerwifi",
  components: { Head, Footer,Hover },
};
</script>

<style>
@import "../assets/css/center.css";

.main_context_wifi {
  width: 1026px;
  flex-direction: row;
  align-items: center;
  display: contents;
}

.main_context_wifi span {
  width: 50%;
  height: 400px;
  display: inline-block;
  margin-top: 30px;
  margin-left: 1px;
}

.main_context_wifi img {
  width: 398px;
  height: 398px;
  display: inline-block;
  border: 0px;
}

.title_context_wifi {
  font-size: 40px;
  font-weight: 600;
  width: 100%;
  display: inline-block;
  color: #333333;
  height: 60px;
  line-height: 60px;
  text-align: left;
  padding-left: 10%;
}

.wifi_image {
  margin-top: 3%;
  height: 460px !important;
}

.memo_context_wifi {
  font-size: 16px;
  font-weight: 400;
  color: #666666;
  line-height: 25px;
  display: block;
  width: 90%;
  text-align: left;
  height: 200px;
  padding-left: 10%;
}

.memo_botton_wifi {
  width: 100%;
  height: auto;
  display: inline-block;
}

.imagewifi {
  display: inline-block;
  text-align: center;
  margin-top: -20px;
  padding: 0px 2%;
  width: 180px;
}

.imagewifi img {
  height: 84px;
  width: 84px;
  border: 0px;
  display: inline-block;
}

.imagewifi span {
  display: inline-block;
  color: #aaaaaa;
  font-size: 13px;
  width: 180px;
  font-weight: 400;
  height: 20px;
  line-height: 20px;
  margin-top: -20px;
}
</style>



// WEBPACK FOOTER //
// src/view/center_wifi.vue